import React from "react";
import { Grid } from "@mui/material";
import NotificationCard from "./NotificationCard";
import {useTheme} from "@mui/material/styles"

const notifications = [
  { id: 1, message: "Order Id 250 has been delivered.", date: "28-09-2023" },
  { id: 2, message: "You have a new order with order id 231. Go to order Details page to accept it.", date: "28-09-2023" },
  { id: 3, message: "Order Id 211 has been cancelled by the user.", date: "28-09-2023" },
  { id: 4, message: "Order Id 250 has been delivered.", date: "27-09-2023" },
  { id: 5, message: "You have a new order with order id 231. Go to order Details page to accept it.", date: "27-09-2023" },
  { id: 6, message: "Order Id 211 has been cancelled by the user.", date: "27-09-2023" },
];

export const Notifications = () => {
  const theme= useTheme();
  return (
    <Grid container sx={{background: theme.palette.background.main}}>
      {notifications.map((notification) => (
        <NotificationCard
          key={notification.id}
          id={notification.id}
          message={notification.message}
          date={notification.date}
        />
      ))}
    </Grid>
  );
};
